'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const AmpliencePage = dynamic(() => import('../../../components/amplience/page'));
const AmplienceContentCard = dynamic(() => import('../../../components/amplience/content-card'));
const AmplienceLayout = dynamic(() => import('../../../components/amplience/layout'));
const AmplienceHeroBanner = dynamic(() => import('../../../components/amplience/hero-banner'));
const AmplienceHeadline = dynamic(() => import('../../../components/amplience/headline'));
const AmplienceSpacer = dynamic(() => import('../../../components/amplience/spacer'));
const AmplienceFooter = dynamic(() => import('../../../components/amplience/footer'));
const AmplienceBannerCarousel = dynamic(() => import('../../../components/amplience/banner-carousel'));
const AmplienceImageComponent = dynamic(() => import('../../../components/amplience/image'));
const AmplienceBreadcrumbs = dynamic(() => import('../../../components/amplience/breadcrumbs'));
const AmplienceText = dynamic(() => import('../../../components/amplience/text'));
const AmpliencePLPPlaceholder = dynamic(() => import('../../../components/amplience/plp-placeholder'));
const AmplienceBlogTags = dynamic(() => import('../blog-tags'));
const AmplienceContainer = dynamic(() => import('../../../components/amplience/container'));
const AmplienceTabNavigation = dynamic(() => import('../../../components/amplience/tab-navigation'));
const AmplienceIframePlaceholder = dynamic(() => import('../iframe-placeholder'));
const AmplienceTrackeableForm = dynamic(() => import('../trackeable-form'));
const AmpliencePLPBreadcrumbPlaceholder = dynamic(
  () => import('../../../components/amplience/plp-breadcrumb-placeholder'),
);
const AmplienceRecentlyViewedPlaceholder = dynamic(() => import('../recently-viewed-placeholder'));
const AmplienceSocialShare = dynamic(() => import('../social-share'));

const AmplienceDynamicComponent = ({ data, ...props }: any) => {
  const schema = data?.['_meta']?.schema?.split('/')?.pop();
  const componentData = { ...data, ...props };

  switch (schema) {
    case 'page-slot':
    case 'page':
      return <AmpliencePage {...componentData} />;
    case 'content-card':
      return <AmplienceContentCard {...componentData} />;
    case 'layout-2-column':
      return <AmplienceLayout numberOfColumns={2} {...componentData} />;
    case 'layout-3-column':
      return <AmplienceLayout numberOfColumns={3} {...componentData} />;
    case 'layout-4-column':
      return <AmplienceLayout numberOfColumns={4} {...data} />;
    case 'container':
      return <AmplienceContainer {...data} />;
    case 'hero-banner':
      return <AmplienceHeroBanner {...componentData} />;
    case 'headline':
      return <AmplienceHeadline {...componentData} />;
    case 'spacer':
      return <AmplienceSpacer {...componentData} />;
    case 'footer':
      return <AmplienceFooter {...componentData} />;
    case 'banner-carousel':
      return <AmplienceBannerCarousel {...componentData} />;
    case 'image':
      return <AmplienceImageComponent {...data} />;
    case 'breadcrumbs':
      return <AmplienceBreadcrumbs {...componentData} />;
    case 'text':
      return <AmplienceText {...componentData} />;
    case 'plp-placeholder':
      return <AmpliencePLPPlaceholder {...componentData} />;
    case 'trackeable-form':
      return <AmplienceTrackeableForm {...data} />;
    case 'plp-breadcrumb-placeholder':
      return <AmpliencePLPBreadcrumbPlaceholder {...componentData} />;
    case 'blog-tags':
      return <AmplienceBlogTags {...data} />;
    case 'tab-navigation':
      return <AmplienceTabNavigation {...data} />;
    case 'iframe-placeholder':
      return <AmplienceIframePlaceholder {...componentData} />;
    case 'recently-viewed-placeholder':
      return <AmplienceRecentlyViewedPlaceholder {...data} />;
    case 'social-share':
      return <AmplienceSocialShare {...data} />;
    default:
      return <div>UNRECOGNIZED COMPONENT</div>;
  }
};

export default AmplienceDynamicComponent;
